import { CreditCardData } from '../types';

/**
 * Return from the given data only properties which are present in credit card data.
 */
const getCreditCardData = ({
  cardNumber,
  expirationMonth,
  expirationYear,
  nameOnCard,
  verificationCode,
}: CreditCardData): CreditCardData => ({
  cardNumber,
  expirationMonth,
  expirationYear,
  nameOnCard,
  verificationCode,
});

export default getCreditCardData;
